export default function Home() {
    return (
        <>
            <br />
            <br />
            <br />
            <div className="container center">
                <p><b>Senior Expert Software Engineer</b></p>
                <p>Team Lead - Architect - Agentic Engineer - DevOps - Cloud Engineer - Fullstack</p>
                <p>Based in Munich, Germany</p>
                <br />
            </div>
            <div className="container center" style={{ textAlign: "left" }}>
                <ul>
                    <li>Well-versed in numerous software technologies including Java, Python, Typescript, Databases, Kafka, Azure, AWS, Kubernetes, Linux</li>
                    <li>Worked on over 15 successful software projects</li>
                    <li>Clean Code advocate</li>
                    <li>Responsible roles as Team Lead, Tech Lead and Architect</li>
                    <li>Continuously improving technical and process skills</li>
                    <li>Strong customer orientation</li>
                    <li>Delivery of high quality software</li>
                    <li>Deeply passionate about IT security</li>
                    <li>Embracing agile principles</li>
                    <li>Strong focus on software architecture and design</li>
                    <li>Involved in every aspect of the software life cycle</li>
                    <ul>
                        <li>Requirements engineering</li>
                        <li>Bid management</li>
                        <li>Conception and design</li>
                        <li>Implementation</li>
                        <li>Build, integration and delivery</li>
                        <li>Testing, QA and customer approval</li>
                        <li>Security reviews and penetration testing</li>
                        <li>Support and customer relations</li>
                        <li>Knowledge transfer</li>
                    </ul>
                    <li>Quick to master complex subjects across changing industries</li>
                    <li>Cooperative and effective teamwork with various customers in international corporations and distributed teams</li>
                    <li>Successful kickoff of greenfield projects</li>
                    <li>Ongoing evolution, extension, migration and refactoring of long-running legacy projects</li>
                    <li>Member of tech leading teams (e.g. first cloud team at a big international corporation)</li>
                    <li>Strong background in project management</li>
                    <li>Cross-functional work: mentoring, technical interviewing, member of a company-internal "campus" group dedicated to quality improvement and coaching, and much more</li>
                </ul>
            </div>
        </>
    )
}
